import { combineReducers } from "redux";
import * as constants from "../constants";
import form from "./form";
import identity from "./identity";
import support from "./support";

export const order = (state = { loading: true }, action) => {
  switch (action.type) {
    case constants.SET_ORDER:
      return {
        loading: false,
        ...action.payload,
      };
    case constants.SET_ORDER_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export const bankAccountsOrder = (state = { loading: true }, action) => {
  switch (action.type) {
    case constants.SET_BANK_ACCOUNTS_ORDER:
      return {
        loading: false,
        ...action.payload,
      };
    case constants.SET_BANK_ACCOUNTS_ORDER_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

const accessKeys = (state = { loading: true }, action) => {
  switch (action.type) {
    case constants.GET_ACCESS_KEYS:
      return {
        loading: false,
        ...action.payload,
      };

    default:
      return state;
  }
};

const createAccessKey = (state = null, action) => {
  switch (action.type) {
    case constants.CREATE_ACCESS_KEY:
      return { ...action.payload };

    default:
      return state;
  }
};

const deactivateAccessKey = (state = null, action) => {
  switch (action.type) {
    case constants.DEACTIVATE_ACCESS_KEY:
      return { ...action.payload };

    default:
      return state;
  }
};

export const makeActionCreator = type => payload => ({ type, payload });

// action types

const SET_FILE = "SET_FILE";
const SET_ERRORS = "SET_ERRORS";
const SET_COLLECT_METHOD = "SET_COLLECT_METHOD";
const SET_SHOW_SELFIE_INSTRUCTION = "SET_SHOW_SELFIE_INSTRUCTION";

// action creators

export const setFile = makeActionCreator(SET_FILE);
export const setErrors = makeActionCreator(SET_ERRORS);
export const setCollectMethod = makeActionCreator(SET_COLLECT_METHOD);
export const setShowSelfieInstruction = makeActionCreator(
  SET_SHOW_SELFIE_INSTRUCTION
);

// state

const types = ["id_front", "id_back", "selfie", "proof_of_residence"];

export const COLLECT_UPLOAD = "COLLECT_UPLOAD";
export const COLLECT_CAPTURE = "COLLECT_CAPTURE";

const initialState = {
  files: types.reduce((acc, type) => {
    return {
      ...acc,
      [type]: {
        type,
        status: null,
        src: null,
      },
    };
  }, {}),
  errors: null,
  collectMethod: COLLECT_UPLOAD,
  showSelfieInstruction: false,
};

//reducer

const verification = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FILE:
      return {
        ...state,
        files: {
          ...state.files,
          [payload.type]: payload,
        },
      };

    case SET_ERRORS:
      return {
        ...state,
        errors: payload,
      };

    case SET_COLLECT_METHOD:
      return {
        ...state,
        collectMethod: payload,
      };

    case SET_SHOW_SELFIE_INSTRUCTION:
      return {
        ...state,
        showSelfieInstruction: payload,
      };

    default:
      return state;
  }
};

const generalError = (state = null, {type, payload }) => {
  switch (type) {
    case constants.GENERAL_ERROR:
      return payload;

    default:
      return state;
  }
}

const autobillsOrder = (state = null, { type, payload }) => {
  switch (type) {
    case constants.SET_AUTOBILLS_ORDER:
      return payload;
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  generalError,
  order,
  form,
  identity,
  support,
  accessKeys,
  createAccessKey,
  deactivateAccessKey,
  verification,
  autobillsOrder,
  bankAccountsOrder,
});

export default rootReducer;
